import { render, staticRenderFns } from "./AdWidget.vue?vue&type=template&id=18d5a12b&scoped=true"
import script from "./AdWidget.vue?vue&type=script&lang=js"
export * from "./AdWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d5a12b",
  null
  
)

export default component.exports